/**
 * Heuristics for paid search / ads landing traffic (matches common UTM + click IDs).
 * @param {URLSearchParams} params
 */
export function inferTrafficSource(params) {
    const gclid = params.get('gclid');
    const wbraid = params.get('wbraid'); // GA4 Ads iOS WBRAID
    const gbraid = params.get('gbraid');
    const msclkid = params.get('msclkid');

    const utmSource = (params.get('utm_source') || '').toLowerCase();
    const utmMedium = (params.get('utm_medium') || '').toLowerCase();

    const fromGoogleAds = Boolean(gclid || wbraid || gbraid) ||
        utmMedium.includes('cpc') ||
        utmMedium.includes('ppc') ||
        utmMedium.includes('paid') ||
        (utmSource === 'google' && (utmMedium === 'cpc' || utmMedium === '')) ||
        params.has('gad_source');

    const fromMicrosoftAds = Boolean(msclkid) ||
        utmSource === 'bing' ||
        utmSource === 'msn' ||
        utmSource === 'microsoft';

    return { fromGoogleAds, fromMicrosoftAds, gclid, msclkid, wbraid, gbraid };
}
